import React from 'react'
import { createContext, useHandler } from 'labguard-cdk'

/**
 * Context used to manage the current group
 */
export default createContext(
  Provider =>
    function GroupContext(props) {
      // create plan edit mode state
      const [isPlanEditMode, setPlanEditMode] = React.useState(false)

      // create toggler
      const togglePlanEditMode = useHandler(() => setPlanEditMode(!isPlanEditMode))

      // provide value to Provider component
      return (
        <Provider
          value={{
            isPlanEditMode,
            togglePlanEditMode,
            setPlanEditMode,
          }}
          {...props}
        />
      )
    }
)
